import React from "react";
import { Link } from "react-router-dom";
import { Trophy, ArrowLeft, Sparkles } from "lucide-react";
import BookLink from "@/components/site/BookLink";

/**
 * Fallback for the /membership route while the membership feature flag is off.
 * Replaces the previous "404 Off the Pitch" page with a friendly themed
 * "coming soon" message that doesn't make a casually curious user think the
 * site is broken.
 */
const MembershipComingSoon = () => (
  <div className="bg-black text-spike-text min-h-[80vh] flex items-center" data-testid="membership-coming-soon">
    <div className="max-w-3xl mx-auto px-6 py-20 text-center w-full">
      <div className="inline-flex items-center gap-2 text-xs font-orbitron font-bold text-spike-blue-light tracking-[0.4em] uppercase">
        <Sparkles className="w-3.5 h-3.5" /> Memberships
      </div>

      <h1 className="mt-5 font-orbitron text-4xl sm:text-5xl lg:text-6xl font-black uppercase text-spike-text leading-[0.95] tracking-tight">
        Still in the <span className="text-spike-blue-light">nets.</span>
      </h1>

      <p className="mt-6 max-w-2xl mx-auto text-base sm:text-lg text-spike-text-muted font-exo leading-relaxed">
        Our membership plans are padding up in the dressing room — we&apos;re wiring payments
        and getting every drill, lane and machine credit ready before they take the field.
        We&apos;ll send the signal the moment they&apos;re ready to bat.
      </p>

      <div className="mt-8 inline-flex items-center gap-2 bg-spike-blue/10 border border-spike-blue/30 text-spike-blue-light px-4 py-2 rounded-sm font-orbitron text-[0.7rem] uppercase tracking-[0.3em]">
        <Trophy className="w-3.5 h-3.5" /> Launching soon
      </div>

      <p className="mt-10 text-sm text-spike-dim font-exo">
        In the meantime — book a single lane and come hit some sixes.
      </p>

      <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
        <BookLink
          data-testid="coming-soon-book-btn"
          className="inline-flex items-center justify-center gap-2 bg-spike-blue hover:bg-spike-blue-hover text-black font-orbitron font-bold uppercase tracking-[0.2em] text-xs px-6 py-3.5 rounded-sm transition-colors shadow-md shadow-spike-blue/40"
        >
          Book a Lane
        </BookLink>
        <Link
          to="/"
          data-testid="coming-soon-home-link"
          className="inline-flex items-center justify-center gap-2 text-spike-text-muted hover:text-spike-text font-orbitron font-bold uppercase tracking-[0.2em] text-xs px-6 py-3.5 border border-white/15 hover:border-spike-blue/40 rounded-sm transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Back to Home
        </Link>
      </div>
    </div>
  </div>
);

export default MembershipComingSoon;
